import "./styles.css"

type ButtonExportExcelProps = {
    onClick: () => void;
}

export function ButtonExportExcel({ onClick }: ButtonExportExcelProps) {
    return (
        <button
            className="buttonExportExcel no-print"
            onClick={onClick}
            type="button"
        >
            Exportar Excel
        </button>
    )
}

